(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shoppable-floating"] && !Shopify.designMode) return;
  try {
    (function () {
  // Poll for YT.Player instead of taking over window.onYouTubeIframeAPIReady:
  // theme.js only sets that callback when it is undefined, and the API may already
  // have loaded (theme.liquid includes it) before this runs.
  window.ShoppableFloatingYT = window.ShoppableFloatingYT || {
    onReady: function (cb) {
      if (window.YT && typeof window.YT.Player === 'function') { cb(); return; }
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
      var tries = 0;
      var interval = setInterval(function () {
        tries++;
        if (window.YT && typeof window.YT.Player === 'function') {
          clearInterval(interval);
          cb();
        } else if (tries > 100) {
          clearInterval(interval);
        }
      }, 100);
    }
  };

  // Video work never competes with the page: wait for window.load, then an idle moment.
  function afterPageLoad(callback) {
    var run = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 2000 });
      } else {
        setTimeout(callback, 200);
      }
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function vimeoReady(cb) {
    if (window.Vimeo && window.Vimeo.Player) { cb(); return; }
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (window.Vimeo && window.Vimeo.Player) {
        clearInterval(interval);
        cb();
      } else if (tries > 40) {
        clearInterval(interval);
      }
    }, 100);
  }

  function extractYouTubeId(url) {
    if (!url) return null;
    var match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  }

  function extractVimeoId(url) {
    if (!url) return null;
    var match = url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
    return match ? match[1] : null;
  }

  function getInstagramEmbedSrc(url) {
    if (!url) return null;
    var match = url.match(/instagram\.com\/(p|reel|tv)\/([A-Za-z0-9_-]+)/);
    if (!match) return null;
    return 'https://www.instagram.com/' + match[1] + '/' + match[2] + '/embed/';
  }

  function getTikTokEmbedSrc(url) {
    if (!url) return null;
    var match = url.match(/tiktok\.com\/@[\w.-]+\/video\/(\d+)/) || url.match(/tiktok\.com\/.*\/(\d+)/);
    if (!match) return null;
    return 'https://www.tiktok.com/embed/v2/' + match[1];
  }

  function getFacebookEmbedSrc(url) {
    if (!url) return null;
    return 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(url) + '&show_text=0&autoplay=true&mute=1';
  }

  function buildIframe(src, allow) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('allowtransparency', 'true');
    if (allow) iframe.setAttribute('allow', allow);
    iframe.src = src;
    return iframe;
  }

  function initShoppableFloating(root) {
    var wrapper = root.querySelector('#shoppableFloting');
    if (!wrapper || wrapper.dataset.initialized === 'true') return;
    wrapper.dataset.initialized = 'true';

    var renderMode = wrapper.getAttribute('data-render-mode');
    var externalUrl = wrapper.getAttribute('data-video-url');
    var fileUrl = wrapper.getAttribute('data-video-file-url');
    var floatingSlot = wrapper.querySelector('[data-role="floating-slot"]');
    var closeFloatingBtn = wrapper.querySelector('[data-role="close-floating"]');
    var openTrigger = wrapper.querySelector('[data-role="open-modal"]');

    var modal = root.querySelector('#shoppableModal');
    if (modal) modal.setAttribute('data-render-mode', renderMode);
    var modalSlot = modal ? modal.querySelector('[data-role="modal-slot"]') : null;
    var modalDialog = modal ? modal.querySelector('[data-role="modal-dialog"]') : null;
    var closeModalBtn = modal ? modal.querySelector('[data-role="close-modal"]') : null;
    var overlay = modal ? modal.querySelector('[data-role="modal-overlay"]') : null;
    var muteBtn = modal ? modal.querySelector('[data-role="toggle-mute"]') : null;
    var iconUnmuted = muteBtn ? muteBtn.querySelector('[data-icon="unmuted"]') : null;
    var iconMuted = muteBtn ? muteBtn.querySelector('[data-icon="muted"]') : null;

    var ytPlayer = null;
    var vimeoPlayer = null;
    var isMuted = true;
    var playerHost = null;
    var fallbackLoadedInModal = false;

    function setMuteIconState(muted) {
      if (iconUnmuted) iconUnmuted.hidden = muted;
      if (iconMuted) iconMuted.hidden = !muted;
    }

    function movePlayerTo(targetSlot) {
      if (!playerHost || !targetSlot) return;
      targetSlot.appendChild(playerHost);
    }

    if (closeFloatingBtn) {
      closeFloatingBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (ytPlayer && ytPlayer.destroy) ytPlayer.destroy();
        if (vimeoPlayer && vimeoPlayer.unload) vimeoPlayer.unload();
        wrapper.remove();
        if (modal) modal.remove();
      });
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      movePlayerTo(modalSlot);

      if (!fallbackLoadedInModal && (renderMode === 'instagram' || renderMode === 'tiktok' || renderMode === 'facebook')) {
        fallbackLoadedInModal = true;
        var src = null;
        var allow = 'autoplay; encrypted-media';
        if (renderMode === 'instagram') src = getInstagramEmbedSrc(externalUrl);
        if (renderMode === 'tiktok') src = getTikTokEmbedSrc(externalUrl);
        if (renderMode === 'facebook') src = getFacebookEmbedSrc(externalUrl);

        if (src) {
          playerHost = buildIframe(src, allow);
          modalSlot.appendChild(playerHost);
        }
        if (muteBtn) muteBtn.hidden = true;
      }

      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.classList.remove('is-open');
      var done = false;
      var onEnd = function () {
        if (done) return;
        done = true;
        clearTimeout(fallback);
        modal.hidden = true;
        document.body.style.overflow = '';
        movePlayerTo(floatingSlot);
        modalDialog.removeEventListener('transitionend', onEnd);
      };
      modalDialog.addEventListener('transitionend', onEnd);
      // transitionend never fires when transitions are disabled (e.g. reduced motion)
      var fallback = setTimeout(onEnd, 400);
    }

    if (openTrigger) openTrigger.addEventListener('click', openModal);
    if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        isMuted = !isMuted;
        if (renderMode === 'youtube' && ytPlayer) {
          if (isMuted) { ytPlayer.mute(); } else { ytPlayer.unMute(); }
          setMuteIconState(isMuted);
        } else if (renderMode === 'vimeo' && vimeoPlayer) {
          vimeoPlayer.setMuted(isMuted);
          setMuteIconState(isMuted);
        } else if ((renderMode === 'file' || renderMode === 'direct-video') && playerHost) {
          playerHost.muted = isMuted;
          setMuteIconState(isMuted);
        }
      });
    }

    // Players (and their downloads) are created only after the page has loaded.
    afterPageLoad(function () {
      if (renderMode === 'file' || renderMode === 'direct-video') {
        var srcUrl = renderMode === 'file' ? fileUrl : externalUrl;
        if (srcUrl) {
          var videoEl = document.createElement('video');
          videoEl.src = srcUrl;
          videoEl.autoplay = true;
          videoEl.muted = true;
          videoEl.loop = true;
          videoEl.playsInline = true;
          videoEl.setAttribute('playsinline', '');
          floatingSlot.appendChild(videoEl);
          playerHost = videoEl;
          videoEl.play().catch(function () {});
        }

      } else if (renderMode === 'youtube') {
        var ytId = extractYouTubeId(externalUrl);
        if (ytId) {
          var ytHost = document.createElement('div');
          floatingSlot.appendChild(ytHost);
          window.ShoppableFloatingYT.onReady(function () {
            ytPlayer = new YT.Player(ytHost, {
              videoId: ytId,
              playerVars: {
                autoplay: 1, mute: 1, controls: 0, loop: 1, playlist: ytId,
                playsinline: 1, rel: 0, modestbranding: 1, disablekb: 1
              },
              events: {
                onReady: function (e) {
                  e.target.mute();
                  e.target.playVideo();
                  playerHost = e.target.getIframe();
                  setMuteIconState(true);
                }
              }
            });
          });
        }

      } else if (renderMode === 'vimeo') {
        var vimeoId = extractVimeoId(externalUrl);
        if (vimeoId) {
          var vimeoIframe = buildIframe(
            'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=1&loop=1&background=0&playsinline=1&controls=0',
            'autoplay; fullscreen; picture-in-picture'
          );
          floatingSlot.appendChild(vimeoIframe);
          playerHost = vimeoIframe;
          vimeoReady(function () {
            vimeoPlayer = new Vimeo.Player(vimeoIframe);
            vimeoPlayer.setMuted(true);
            vimeoPlayer.setLoop(true);
            vimeoPlayer.play().catch(function () {});
            setMuteIconState(true);
          });
        }

      } else if (renderMode === 'instagram' || renderMode === 'tiktok' || renderMode === 'facebook') {
        playerHost = null;
      }

      wrapper.classList.remove('is-loading');
      wrapper.classList.add('is-ready');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initShoppableFloating(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initShoppableFloating(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('shoppable-reels')) return;

  // Video work never competes with the page: wait for window.load, then an idle moment.
  function afterPageLoad(callback) {
    var run = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 2000 });
      } else {
        setTimeout(callback, 200);
      }
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function canAutoplay() {
    if (navigator.connection && navigator.connection.saveData) return false;
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readJson(element) {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  // Same bag as snippets/icon-cart.liquid used on the slider cards
  var CART_ICON = '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path d="M 16 3 C 13.253906 3 11 5.253906 11 8 L 11 9 L 6.0625 9 L 6 9.9375 L 5 27.9375 L 4.9375 29 L 27.0625 29 L 27 27.9375 L 26 9.9375 L 25.9375 9 L 21 9 L 21 8 C 21 5.253906 18.746094 3 16 3 Z M 16 5 C 17.65625 5 19 6.34375 19 8 L 19 9 L 13 9 L 13 8 C 13 6.34375 14.34375 5 16 5 Z M 7.9375 11 L 11 11 L 11 14 L 13 14 L 13 11 L 19 11 L 19 14 L 21 14 L 21 11 L 24.0625 11 L 24.9375 27 L 7.0625 27 Z"/></svg>';
  var LINK_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>';

  class ShoppableReels extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-reels-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-reel-index]'));
      this.reels = this.slides.map(function (slide) {
        return readJson(slide.querySelector('[data-reel-json]')) || {};
      });
      this.strings = readJson(this.querySelector('[data-reels-strings]')) || {};
      this.modal = this.querySelector('[data-reels-modal]');
      this.cardVideos = Array.prototype.slice.call(this.querySelectorAll('video[data-src]'));
      this.current = 0;
      this.productIndex = 0;
      this.muted = false;
      this.modalOpen = false;

      this.initArrows();
      this.slides.forEach(function (slide, index) {
        var opener = slide.querySelector('[data-reel-open]');
        if (opener) {
          opener.addEventListener('click', this.openModal.bind(this, index, opener));
        }
      }, this);

      if (this.dataset.autoplay === 'true' && this.cardVideos.length && canAutoplay()) {
        afterPageLoad(this.initAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.modalOpen) this.closeModal();
      if (this.modal && this.modal.parentNode === document.body) this.modal.remove();
    }

    initArrows() {
      var prev = this.querySelector('[data-reels-prev]');
      var next = this.querySelector('[data-reels-next]');
      if (!prev || !next || !this.track) return;

      var track = this.track;
      var step = function () {
        var slide = track.querySelector('.shoppable-reels__slide');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      };
      var update = function () {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      var ticking = false;

      prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }, { passive: true });
      update();
    }

    initAutoplay() {
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !this.modalOpen) {
            this.playCardVideo(entry.target);
          } else {
            entry.target.pause();
          }
        }, this);
      }.bind(this), { threshold: 0.6 });

      this.cardVideos.forEach(function (video) {
        video.addEventListener('playing', function () {
          video.classList.add('is-playing');
          video.parentNode.classList.add('is-playing');
        });
        this.observer.observe(video);
      }, this);
    }

    playCardVideo(video) {
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      video.muted = true;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }

    pauseCardVideos() {
      this.cardVideos.forEach(function (video) { video.pause(); });
    }

    resumeCardVideos() {
      if (!this.observer) return;
      // Re-observing fires the callback with each video's current visibility.
      this.cardVideos.forEach(function (video) {
        this.observer.unobserve(video);
        this.observer.observe(video);
      }, this);
    }

    bindModal() {
      if (this.modalBound) return;
      this.modalBound = true;

      var modal = this.modal;
      this.playerSlot = modal.querySelector('[data-modal-slot]');
      this.panel = modal.querySelector('[data-modal-panel]');
      this.progressBar = modal.querySelector('[data-modal-progress] span');
      this.toast = modal.querySelector('[data-modal-toast]');
      this.muteButton = modal.querySelector('[data-modal-mute]');
      this.closeButton = modal.querySelector('.shoppable-reels-modal__close');
      this.sidePrev = modal.querySelector('[data-modal-side="prev"]');
      this.sideNext = modal.querySelector('[data-modal-side="next"]');

      modal.querySelectorAll('[data-modal-close]').forEach(function (button) {
        button.addEventListener('click', this.closeModal.bind(this));
      }, this);
      modal.querySelector('[data-modal-prev]').addEventListener('click', this.step.bind(this, -1));
      modal.querySelector('[data-modal-next]').addEventListener('click', this.step.bind(this, 1));
      this.sidePrev.addEventListener('click', this.step.bind(this, -1));
      this.sideNext.addEventListener('click', this.step.bind(this, 1));
      this.muteButton.addEventListener('click', this.toggleMute.bind(this));
      modal.querySelector('[data-modal-share]').addEventListener('click', this.share.bind(this));

      this.panel.addEventListener('click', function (event) {
        var target = event.target.closest('[data-product-index]');
        if (target) this.renderPanel(Number(target.dataset.productIndex));
      }.bind(this));

      var player = modal.querySelector('[data-modal-player]');
      var startX = 0;
      var startY = 0;
      player.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      player.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.step(dx < 0 ? 1 : -1);
      }.bind(this), { passive: true });

      this.onKeydown = function (event) {
        if (event.key === 'Escape') this.closeModal();
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      }.bind(this);

      // Theme add-to-cart opens the cart drawer/popup underneath; get out of its way.
      this.cartObserver = new MutationObserver(function () {
        var body = document.body.classList;
        if (body.contains('cart-sidebar-show') || body.contains('add-to-cart-show')) this.closeModal();
      }.bind(this));
    }

    openModal(index, opener) {
      if (!this.modal) return;
      this.bindModal();
      // Fixed positioning breaks inside transformed ancestors (scroll animations).
      if (this.modal.parentNode !== document.body) document.body.appendChild(this.modal);

      this.lastFocus = opener;
      this.modalOpen = true;
      this.muted = false;
      this.pauseCardVideos();

      this.modal.classList.toggle('is-single', this.reels.length < 2);
      this.modal.hidden = false;
      document.documentElement.classList.add('shoppable-reels-lock');
      requestAnimationFrame(function () { this.modal.classList.add('is-open'); }.bind(this));

      document.addEventListener('keydown', this.onKeydown);
      this.cartObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      this.showReel(index);
      this.closeButton.focus();
    }

    closeModal() {
      if (!this.modalOpen) return;
      this.modalOpen = false;
      this.clearPlayer();
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      document.documentElement.classList.remove('shoppable-reels-lock');
      document.removeEventListener('keydown', this.onKeydown);
      this.cartObserver.disconnect();
      if (this.lastFocus) this.lastFocus.focus({ preventScroll: true });
      this.resumeCardVideos();
    }

    step(direction) {
      if (this.reels.length < 2) return;
      this.showReel(this.current + direction);
    }

    clearPlayer() {
      var video = this.playerSlot && this.playerSlot.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      if (this.playerSlot) this.playerSlot.innerHTML = '';
      if (this.progressBar) this.progressBar.style.width = '0';
    }

    showReel(index) {
      var total = this.reels.length;
      this.current = (index + total) % total;
      var reel = this.reels[this.current];

      this.clearPlayer();
      this.modal.setAttribute('aria-label', reel.title || '');
      this.modal.classList.toggle('is-embed', reel.mode !== 'file');

      if (reel.mode === 'file') {
        var video = document.createElement('video');
        var progressBar = this.progressBar;
        video.src = reel.src;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        if (reel.poster) video.poster = reel.poster;
        video.muted = this.muted;
        video.addEventListener('timeupdate', function () {
          if (video.duration) progressBar.style.width = (video.currentTime / video.duration) * 100 + '%';
        });
        this.playerSlot.appendChild(video);
        var playing = video.play();
        if (playing && playing.catch) {
          playing.catch(function () {
            // Browser refused sound: fall back to muted autoplay.
            this.muted = true;
            video.muted = true;
            this.updateMuteIcon();
            video.play().catch(function () {});
          }.bind(this));
        }
      } else if (reel.mode === 'youtube' || reel.mode === 'vimeo') {
        var src = reel.mode === 'youtube'
          ? 'https://www.youtube.com/embed/' + encodeURIComponent(reel.embed) + '?autoplay=1&playsinline=1&rel=0&modestbranding=1&loop=1&playlist=' + encodeURIComponent(reel.embed)
          : 'https://player.vimeo.com/video/' + encodeURIComponent(reel.embed) + '?autoplay=1&playsinline=1&loop=1';
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = reel.title || '';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        this.playerSlot.appendChild(iframe);
      }
      this.updateMuteIcon();

      if (total > 1) {
        this.setSide(this.sidePrev, this.reels[(this.current - 1 + total) % total]);
        this.setSide(this.sideNext, this.reels[(this.current + 1) % total]);
      }

      this.renderPanel(0);
    }

    setSide(element, reel) {
      element.style.backgroundImage = reel && reel.poster ? 'url("' + reel.poster.replace(/"/g, '%22') + '")' : '';
    }

    renderPanel(productIndex) {
      var products = (this.reels[this.current] || {}).products || [];
      if (!products.length) {
        this.panel.hidden = true;
        this.panel.innerHTML = '';
        return;
      }

      this.productIndex = Math.max(0, Math.min(productIndex, products.length - 1));
      var product = products[this.productIndex];
      var strings = this.strings;
      var html = '';

      if (product.image) {
        html += '<div class="shoppable-reels-modal__panel-image"><img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" width="120" height="120"></div>';
      }
      if (product.description) {
        html += '<div class="shoppable-reels-modal__panel-desc"><h4>' + escapeHtml(strings.description) + '</h4><div>' + escapeHtml(product.description) + '</div></div>';
      }
      if (products.length > 1) {
        html += '<div class="shoppable-reels-modal__switch">';
        products.forEach(function (item, i) {
          html += '<button type="button" data-product-index="' + i + '" aria-label="' + escapeHtml(item.title) + '"' + (i === this.productIndex ? ' class="is-active" aria-current="true"' : '') + '></button>';
        }, this);
        html += '</div>';
      }

      // price/compare are pre-formatted by Liquid's money filter, so they are inserted as-is
      html += '<div class="shoppable-reels-modal__card">'
        + (product.thumb ? '<img src="' + escapeHtml(product.thumb) + '" alt="" width="56" height="56">' : '<span></span>')
        + '<div class="shoppable-reels__product-info"><a class="shoppable-reels__product-title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>'
        + '<span class="shoppable-reels__product-price">' + product.price + (product.compare ? ' <s>' + product.compare + '</s>' : '') + '</span></div>'
        + '<a class="shoppable-reels__product-link" href="' + escapeHtml(product.url) + '" aria-label="' + escapeHtml(strings.moreInfo) + '">' + LINK_ICON + '</a>'
        + '<div class="shoppable-reels__product-actions">' + this.actionsHtml(product) + '</div>'
        + '</div>';

      this.panel.innerHTML = html;
      this.panel.hidden = false;
    }

    actionsHtml(product) {
      var strings = this.strings;
      var primary;
      if (!product.available) {
        primary = '<button type="button" class="shoppable-reels__btn is-soldout" disabled>' + escapeHtml(strings.soldOut) + '</button>';
      } else if (product.single) {
        // data-btn-addtocart + form[name=id] is picked up by theme.js initAddToCart
        primary = '<form method="post" action="' + escapeHtml(strings.cartAddUrl) + '" class="shoppable-reels__form">'
          + '<input type="hidden" name="id" value="' + escapeHtml(product.variant) + '">'
          + '<input type="hidden" name="quantity" value="1">'
          + '<button type="submit" class="shoppable-reels__btn" data-btn-addtocart>' + escapeHtml(strings.addToCart) + '</button></form>';
      } else {
        primary = '<a class="shoppable-reels__btn" href="' + escapeHtml(product.url) + '">' + escapeHtml(strings.chooseOptions) + '</a>';
      }
      return primary
        + '<a class="shoppable-reels__btn shoppable-reels__btn--outline" href="' + escapeHtml(product.url) + '">' + escapeHtml(strings.moreInfo) + '</a>'
        + '<a class="shoppable-reels__btn shoppable-reels__btn--icon" href="' + escapeHtml(strings.cartUrl) + '" aria-label="' + escapeHtml(strings.cart) + '">' + CART_ICON + '</a>';
    }

    toggleMute() {
      var video = this.playerSlot.querySelector('video');
      if (!video) return;
      this.muted = !this.muted;
      video.muted = this.muted;
      this.updateMuteIcon();
    }

    updateMuteIcon() {
      if (!this.muteButton) return;
      this.muteButton.querySelector('[data-icon="unmuted"]').hidden = this.muted;
      this.muteButton.querySelector('[data-icon="muted"]').hidden = !this.muted;
    }

    share() {
      var reel = this.reels[this.current] || {};
      var product = (reel.products || [])[this.productIndex];
      var url = product ? new URL(product.url, window.location.origin).href : window.location.href;
      var title = product ? product.title : document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          this.showToast(this.strings.copied);
        }.bind(this)).catch(function () {});
      }
    }

    showToast(message) {
      if (!this.toast || !message) return;
      this.toast.textContent = message;
      this.toast.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(function () { this.toast.hidden = true; }.bind(this), 2000);
    }
  }

  customElements.define('shoppable-reels', ShoppableReels);
})();
  } catch(e) { console.error(e); }
})();

})();
